import React from "react";

const ImagePreview = ({ item, onBackToItem }) => {
  // Cek jika item tidak ada
  if (!item) {
    return (
      <div className="text-center">
        <p>Data tidak tersedia.</p>
        <button className="btn btn-primary" onClick={onBackToItem}>
          Back To Item
        </button>
      </div>
    );
  }

  // Parse image_url string ke array
  let imageArray = [];
  try {
    imageArray = JSON.parse(item.image_url || "[]");
  } catch (err) {
    console.error("Gagal parsing image_url:", err);
  }

  return (
    <div className="row justify-content-center mt-3">
      <div className="col-lg-10 text-center">
        <div className="row g-3 mb-4">
          {imageArray.length > 0 ? (
            imageArray.map((filename, index) => (
              <div key={index} className="col-md-4">
                <img
                  src={`${process.env.REACT_APP_API}/images/${filename}`}
                  alt={`Image ${index + 1}`}
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: "300px", objectFit: "contain" }}
                />
              </div>
            ))
          ) : (
            <p>Tidak ada gambar untuk item ini.</p>
          )}
        </div>
        <button className="btn btn-primary" onClick={onBackToItem}>
          Back To Item
        </button>
      </div>
    </div>
  );
};

export default ImagePreview;
